import axios from 'axios';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import { B2C_GA4_TRACKING_ID, EVENTS, GA4_TRACKING_ID } from './configs';
const COOKIE_DOMAIN = 'cleartax.in';

export const getGA4Properties = (action: string) => {
  if (action === EVENTS.pageView) return [GA4_TRACKING_ID, B2C_GA4_TRACKING_ID];
  return [GA4_TRACKING_ID];
};

export const trackActionGA4 = (
  action: string,
  value: Record<string, unknown>
): void => {
  if (window.gtag) {
    const sendProperty = getGA4Properties(action);
    value.send_to = sendProperty;
    window.gtag('event', action, value);
  }
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string, GA_ID: string): void => {
  window.gtag('config', GA_ID, {
    page_path: url,
  });
};

export const sendFunnelMetrics = (queryString: string): void => {
  axios({
    method: 'get',
    url: `/funnelmetrics?${queryString}`,
  }).catch((error) => {
    console.warn('Warning: Funnelmetrics failed', error);
  });
};

export const getPrevLocation = (prevLocation: string): string => {
  if (prevLocation) return prevLocation;
  if (document) return document.referrer;
  return 'unidentified';
};

export const getAdditionalDataFromValue = (value: unknown) => {
  if (value != undefined) {
    if (typeof value === 'object') {
      const additionalData = [];
      for (const key in value) {
        //object will be stored as string retaining it's structure, separated by delimeters
        additionalData.push(
          `"${key}":"${(value as Record<string, string>)[key]}"`
        );
      }
      return { metadata: `{${additionalData}}` };
    } else return { value: value };
  }
};

export const getFunnelMetricParamsFromObject = (
  dataMap: Record<string, unknown>
): string[] => {
  const params = [];
  for (const key in dataMap) {
    params.push(`${key}=${dataMap[key]}`); // encodeURIComponent()
  }
  return params;
};

export const handleConversions = (action: string): void => {
  if (window && window.gtag) {
    if (action == 'complete_purchase') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-948914955/YxCMCOvoqcoBEIuWvcQD',
        transaction_id: '',
      });
    }
  }
};

export const UTMNaming = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  content: 'utm_content',
  id: 'utm_id',
  ref: 'utm_ref',
  term: 'utm_term',
};

export const setUTMParamInCookie = (
  query: string | Record<string, string>
): void => {
  const cookieNamePrefix = 'ct_';
  const utmParams = [
    UTMNaming.source,
    UTMNaming.medium,
    UTMNaming.campaign,
    UTMNaming.content,
    UTMNaming.id,
    UTMNaming.ref,
    UTMNaming.term,
  ];
  const queryParams = new URLSearchParams(query);
  const hasUtmParams = utmParams.some((param) => queryParams.has(param));

  if (!hasUtmParams) return;

  utmParams.forEach((param) => {
    const value = queryParams.get(param) || '';
    const cookieName = cookieNamePrefix + param;
    deleteCookie(cookieName, { path: '/', domain: COOKIE_DOMAIN });
    setCookie(cookieName, value, { domain: COOKIE_DOMAIN });
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getUTMParameters = () => {
  return {
    utm_source: getCookie(`ct_${UTMNaming.source}`) || '',
    utm_medium: getCookie(`ct_${UTMNaming.medium}`) || '',
    utm_campaign: getCookie(`ct_${UTMNaming.campaign}`) || '',
    utm_content: getCookie(`ct_${UTMNaming.content}`) || '',
    utm_id: getCookie(`ct_${UTMNaming.id}`) || '',
    utm_ref: getCookie(`ct_${UTMNaming.ref}`) || '',
    utm_term: getCookie(`ct_${UTMNaming.term}`) || '',
  };
};
